import type { CacheConfig } from 'relay-runtime';

/**
 * Creates a Relay cacheConfig/networkCacheConfig with X-Query-Context header if cloudId is provided.
 * Use this for commitMutation, usePreloadedQuery, loadQuery, and entrypoint options.
 */
export function createQueryContextCacheConfig(cloudId?: string): CacheConfig | undefined {
	if (!cloudId) {
		return undefined;
	}

	return {
		metadata: {
			headers: {
				'X-Query-Context': `ari:cloud:platform::site/${cloudId}`,
			},
		},
	};
}

/**
 * Creates headers object with X-Query-Context header if cloudId is provided.
 * Use this for AGG client makeGraphQLRequest calls and useQueryLight customHeaders.
 */
export function createQueryContextHeaders(cloudId?: string): Record<string, string> | undefined {
	if (!cloudId) {
		return undefined;
	}

	return {
		'X-Query-Context': `ari:cloud:platform::site/${cloudId}`,
	};
}
